import React, { Fragment } from "react";
import RootRouter from "./RootRouter";
import CssBaseline from "@material-ui/core/CssBaseline";

import { isBrowser, isMobile, isAndroid, isIOS } from "react-device-detect";
const App = () => {
    return (
        <Fragment>
            <CssBaseline />
            <RootRouter isBrowser={isBrowser} isMobile={isMobile} isAndroid={isAndroid} isIOS={isIOS} />
        </Fragment>
    );
};
export default App;
